export default __webpack_public_path__ + "static/showReel-d349994802e6f8ddf6e9b168e02b6c42.webm";